import { FC, ReactNode } from "react";

import { Box, Stack } from "@mui/material";

import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface MethodCardProps {
  slots: {
    label: ReactNode;
    title: ReactNode;
    description: ReactNode;
    action: ReactNode;
  };
}

export const MethodCard: FC<MethodCardProps> = ({ slots }) => {
  return (
    <Box
      sx={(theme) => ({
        border: `1px solid ${theme.palette.border.neutral.quiet}`,
        borderRadius: 1,
        p: 2,
        display: "flex",
        flexDirection: "column",
        width: "100%",
      })}
    >
      <Stack spacing={0.5} sx={{ flex: 1 }}>
        <DashboardTypography variant="caption">{slots.label}</DashboardTypography>
        <DashboardTypography variant="subtitle2">{slots.title}</DashboardTypography>
        <DashboardTypography variant="caption" sx={{ color: "text.secondary" }}>
          {slots.description}
        </DashboardTypography>
      </Stack>
      <Box sx={{ pt: 1.5 }}>{slots.action}</Box>
    </Box>
  );
};
